let resolveToasterReady: (() => void) | undefined;
let hasResolvedToasterReady = false;

export const toasterReady = new Promise<void>((resolve) => {
  resolveToasterReady = resolve;
});

export function markToasterReady() {
  if (hasResolvedToasterReady) {
    return;
  }

  hasResolvedToasterReady = true;
  resolveToasterReady?.();
}
